<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://', v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                   | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                .form__field-body
                    cs-multiselect(
                        :options="Array.from(Array(10), (_, i) => i + 1).slice(2)"
                        :custom-label="difficultLabel"
                        v-model="params.difficult"
                        :placeholder="difficultLabel(params.difficult)"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                .form__field-body.form-container__select-examples
                    cs-spin-input(
                        :value="params.numOfExamples",
                        :max="numOfExamples",
                        :min="1",
                        @increase="increaseExamples",
                        @decrease="decreaseExamples",
                        @input="params.numOfExamples = $event",
                        :disabled="params && params.infinityAmountOfExamples"
                    )
                    .form-container__select-infinity-mode(v-if="isInfiniteAmountAvailable")
                        cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                            v-model="params.infinityAmountOfExamples"
                            :checked="params && params.infinityAmountOfExamples"
                        )
                        svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_portal') }}
                .form__field-body
                    cs-multiselect(
                        :options="Array.from(Array(3), (_, i) => i)"
                        :custom-label="portalLabel"
                        v-model="params.portal"
                        :placeholder="'' + portalLabel(params.portal)"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_field') }}
                .form__field-body
                    cs-multiselect(
                        :options="fieldStatuses"
                        v-model="selectedFieldStatus"
                        label="name"
                        track-by="value"
                        :placeholder="selectedFieldStatus.name"
                        @select="fieldStatusHandler"
                        :multiple="false"
                        :allow-empty="false"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfSteps') }}
                .form__field-body
                    cs-spin-input(
                        :value="params.amountOfSteps",
                        :max="numOfSteps",
                        :min="3",
                        @increase="increaseNumOfSteps",
                        @decrease="decreaseNumOfSteps",
                        @input="params.amountOfSteps = $event",
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
                .form__field-body
                    cs-multiselect(
                        :options="seconds.filter(amount => amount <= 5)"
                        v-model="params.speed"
                        :custom-label="secondsLabel"
                        :placeholder="secondsLabel(params.speed)"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            slot(name='parameters')
            //slot(name='help')
            template(v-if='!usersIds')
                .form__buttons
                    cs-button.form__button(pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    template(v-if="gameMode && gameMode === 'free-game'")
                        cs-button.form__button(color="blue" @click='saveGameMode')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                    template(v-else='')
                        cs-button.form__button(color="blue" @click='saveGame')
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            template(v-else='')
                .form__buttons
                    cs-button.form__button(pattern="primary-outline" color="blue" @click='cancel')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                    cs-button.form__button(color="blue" @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer.json';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import IntervalConfig from '../../trainer/configs/IntervalConfig'
    import { mapState } from 'vuex';
    import _ from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                fieldStatuses: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_opened'),
                        value: true
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_closed'),
                        value: false
                    }
                ],
                numOfExamples: 15,
                numOfSteps: 100,
                params: null,
                seconds: IntervalConfig.secondsForNavigator,
                selectedFieldStatus: {}
            }
        },
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    const courseType = _.kebabCase(this.courseType);
                    this.params = _.cloneDeep(TrainerGames.games).find((item) => item.slug === this.slug && item.courseType === courseType).parameters.default;
                }
                this.isMentalArithmeticGame && (this.params.infinityAmountOfExamples = true);
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.selectedFieldStatus = this.fieldStatuses.find(status => status.value === this.params.isFieldOpened);
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            isMentalArithmeticGame () {
                return this.courseType === 'mentalArithmetic';
            },
            isInfiniteAmountAvailable () {
                return this.gameMode && this.gameMode === 'free-game' && this.isMentalArithmeticGame;
            }
        },
        methods: {
            difficultLabel(value) {
                return value + ' x ' + value;
            },
            portalLabel(value) {
                return value === 0 ? this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated') : value;
            },
            fieldStatusHandler(status) {
                this.params.isFieldOpened = status.value;
            },
            secondsLabel(amount) {
                return amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds')
            },
            decreaseExamples () {
                if (this.params.numOfExamples !== 1 && !this.params.infinityAmountOfExamples) {
                    this.params.numOfExamples -= 1;
                }
            },
            increaseExamples () {
                if (this.params.numOfExamples !== this.numOfExamples && !this.params.infinityAmountOfExamples) {
                    this.params.numOfExamples += 1;
                }
            },
            decreaseNumOfSteps() {
                if (this.params.amountOfSteps !== 3) {
                    this.params.amountOfSteps -= 1;
                }
            },
            increaseNumOfSteps() {
                if (this.params.amountOfSteps !== this.numOfSteps) {
                    this.params.amountOfSteps += 1;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox{
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }
</style>
